import { ComponentPropsWithoutRef, FC } from 'react';
import classNames from 'classnames';
import styles from './Table.scss';

interface TableProps extends ComponentPropsWithoutRef<'table'> {
  fixed?: boolean;
}

export const Table: FC<TableProps> = ({ fixed, className, children }) => {
  return (
    <div className={classNames('l-overflow-scroll', styles.scrollWrapper)}>
      <table className={classNames('m-table-list', fixed && 'm-table-fixed', styles.table, className)}>
        {children}
      </table>
    </div>
  );
};
